import { useContext, useEffect, useRef } from 'react';

import { media } from 'context';
import WorkspaceCard, { Props as WorkspaceCardProps } from 'ds/WorkspaceCard';

import Layout from './Layout';
import SearchMapWorkspaceCard from './SearchMapWorkspaceCard';
import { DEMO_SEARCH_WORKSPACE } from './workspace-data';

interface Props extends Pick<WorkspaceCardProps, 'width' | 'landscape' | 'size'> {
  useEffectDependency?: boolean;
  type?: 'search';
  setCardRect: (rect: DOMRect) => void;
}

const GhostWorkspaceCard = ({ width, setCardRect, landscape, size, type }: Props) => {
  const cardRef = useRef<HTMLDivElement>(null);
  const { screenSize } = useContext(media);

  useEffect(() => {
    if (!cardRef.current) return;

    setCardRect(cardRef.current.getBoundingClientRect());
  }, [screenSize]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Layout
      __ref={cardRef}
      visibility="hidden"
      position="absolute"
      onMeasure={cardRect => {
        setCardRect(cardRect);
      }}
    >
      {type ? (
        <SearchMapWorkspaceCard workspace={{ ...DEMO_SEARCH_WORKSPACE }} daysPerWeek={3} />
      ) : (
        <WorkspaceCard width={width} landscape={landscape} size={size} workspace={{ ...DEMO_SEARCH_WORKSPACE }} />
      )}
    </Layout>
  );
};

export default GhostWorkspaceCard;
